  <pru-modal
    class="pru-modal in"
    aria-labelledBy="standardModal"
    id="session-timeout-dialog">
    
    <pru-modal-header
        id="session-timeout-dialog-header"
        css="pru-modal-header">
      <h2 class="modal-title" id="standardModal">{{ props.title }}</h2>
    </pru-modal-header>
    <pru-modal-body>
      <p>{{props.message}}</p>
      <div *ngIf="props.countdownBar" class="progress">
        <div class="progress-bar progress-bar-striped countdown-bar active" id="countdownBar" role="progressbar" [style.width]="countdownWidth" style="min-width: 15px;" #countdownBar>
          <span class="countdown-holder" id="countdownHolder" #countdownHolder>{{ props.countdownText }}</span>
        </div>
      </div>
    </pru-modal-body>
    <pru-modal-footer>
      <button id="session-timeout-dialog-logout" type="button" class="btn btn-default" (click)="onSessionLogout()">{{ props.logoutButton }}</button>
      <button id="session-timeout-dialog-keepalive" type="button" class="btn btn-primary" (click)="onStayConnected()">{{ props.keepAliveButton }}</button>
    </pru-modal-footer>
  </pru-modal>